module.exports = __webpack_public_path__ + "static/media/module-member.ff832b74.png";